import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent } from '@ionic/react'
import { UseHeader, MktConfirmModal } from '@cps'
import { format } from '@dt/fe-utils'
import { modalLayer, formatCardNumber, formatShortPrivate, toast } from '@utils'
import { MemberApi } from '@api/index'
import { CardShape } from 'pages/mkt/components'
import mktController from 'controllers/mktController'
import { getGiftCardName } from '@common/utils/giftcard'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  recordInfo: any;
  resolve?: () => void;
  reject?: () => void;
}

const GiftCardDetail: FC<IProps> = (props: IProps) => {
  const { recordInfo, resolve, reject } = props
  const giftCardStatus = {
    bind: i18n.t('mkt.giftCard.cardIsBound'),
    unbind: i18n.t('mkt.giftCard.notBound'),
    cancel: i18n.t('mkt.giftCard.cancleSend')
  }
  const cancelGive = () => {
    modalLayer(MktConfirmModal, {
      cssClass: 'cancle-gc-modal',
      title: getGiftCardName('mkt.giftCard.cancleGiveTit', 'mkt.giftCard.cancleGiveTitCustom')
    }, 'MktConfirmModal').then(() => {
      MemberApi.cancelGiveGc({
        giftcardGiveId: Number(recordInfo.giftcardGiveId),
      }).then((res) => {
        let msg = i18n.t('mkt.giftCard.unbindFailTip')
        if (res === 'success') msg = i18n.t('mkt.coupon.transferCancel')
        if (res?.code === 4006) msg = i18n.t('mkt.giftCard.cardIsBindTip')
        toast({ message: msg, position: 'bottom' })
        resolve()
      })
    }, () => {})
  }
  return (
    <IonModal
      isOpen
      cssClass='gift-record-detail'
    >
      <UseHeader onBack={reject} title={getGiftCardName('pageName.giftCard', 'mkt.giftCard.myGiftCardCustom')}></UseHeader>
      <IonContent class='page-content'>
        <div className='modal-body'>
          <div className={`card-cover${!recordInfo.giveMemberCard?.extra?.shape || recordInfo.giveMemberCard.extra.shape === 'rectangle' ? ' rectangle' : ''}`}>
            <CardShape shape={recordInfo.giveMemberCard?.extra?.shape || 'rectangle'} cardFace={mktController.getGiveGifCardCover(recordInfo)} border='shadow' isScale={false}></CardShape>
          </div>
          <div className='detail-group detail-card'>
            <div className='card-name'>{recordInfo.giftcard.giftcardName}</div>
            <div className='card-info'>
              <div className='cardno'>{formatCardNumber(formatShortPrivate(recordInfo.cardNo, 4, 4))}</div>
              {recordInfo?.giveMemberCard?.cardPin && (<div>Pin code: {formatShortPrivate(recordInfo.giveMemberCard.cardPin, 1, 1)}</div>)}
            </div>
          </div>
          <div className='detail-group'>
            <div className='group-top'>
              <div className='title'>{i18n.t('mkt.giftCard.transferInfo')}</div>
            </div>
            <div className='basic-list'>
              {
                recordInfo.receiverEmail || recordInfo.receiverMobile
                  ? (
                    <div className='basic-item'>
                      <span>{recordInfo.receiverEmail ? i18n.t('mkt.giftCard.receiveMail') : i18n.t('mkt.giftCard.receiveMobile')} </span>
                      {recordInfo.receiverEmail ? <span className='info'>{recordInfo.receiverEmail}</span> : <span className='info'>+{recordInfo.countryCode} {recordInfo.receiverMobile}</span>}
                    </div>
                  ) : ''
              }
              <div className='basic-item'>
                <span>{i18n.t('mkt.giftCard.donationStatus')}</span>
                <span className={`info ${recordInfo.status === 'unbind' ? 'red' : ''}`}>{giftCardStatus[recordInfo.status]}</span>
              </div>
              <div className='basic-item'>
                <span>{i18n.t('mkt.giftCard.transferTime')}</span>
                <span className='info'>{format.toDateTime(recordInfo.addTime)}</span>
              </div>
              <div className='basic-item'>
                <span>{i18n.t('mkt.giftCard.donationTime')}</span>
                <span className='info'>{recordInfo.receiveTime ? format.toDateTime(recordInfo.receiveTime) : '--'}</span>
              </div>
            </div>
            {
              recordInfo.status === 'unbind' && <div data-cypid='mmgCancelGiveGCard' className='cancle-send' onClick={cancelGive}>{i18n.t('mkt.giftCard.cancleSend')}</div>
            }
          </div>
        </div>
      </IonContent>
      {/* {
        recordInfo && recordInfo.status === 'unbind'
          ? (
            <IonFooter>
              <div className='cancel-btn' onClick={cancelGive}>
                <span>{i18n.t('mkt.common.unGift')}</span>
              </div>
            </IonFooter>
          ) : ''
      } */}
    </IonModal>
  )
}

export default observer(GiftCardDetail)
